import React from 'react';

import { Box } from '@nerdwallet/currency/components/Box';
import { Title } from '@nerdwallet/currency/components/Title';
import { Type } from '@nerdwallet/currency/components/Type';

interface Props {
  title: string;
  subtext?: string;
}

const FriendlyTitle = ({ title, subtext }: Props) => (
  <Box marginBottom={4}>
    <Title chronicle size="small">
      {title}
    </Title>
    {subtext && (
      <Box marginTop={3}>
        <Type>{subtext}</Type>
      </Box>
    )}
  </Box>
);

export default FriendlyTitle;
